//可異步操作
// npm
import axios, { actionEnhancer } from '@/utils/axios';
// router
import router from '@/router';
// insurance constants
import {
  INSU_REQUEST_MUTATION,
 // FETCH_INSU_ACTION,
 // FETCH_DETAILS_ACTION,
 // SET_QUERY_MUTATION,
 // SET_PRODUCTS_MUTATION,
//  RESET_PRODUCTS_MUTATION,
  INSU_MODAL_MUTATION,
 // HANDLE_PAGE_SCROLL,
  HANDLE_PURCHASE_ACTION2
} from './constants';
// checkout constanst
import { 
  SET_INSUINFOS,
  SET_TRAVELFILTER_FORM,
  SET_CARPROFILE,
  SET_MOTORPROFILE,
  SET_CHECKOUT_PRODPOLICIES//
} from '../checkout/constants';
// utils
//import animateScroll from '@/utils/animateScroll';

//const catchErrors = actionEnhancer(INSU_REQUEST_MUTATION);
/*
const fetchInsurances = catchErrors(
  async ({ commit }, { type, tips, formatCarNo = null, ...queryModel }) => {
    const { currentRoute: { name } } = router;
    const insus = {
      travel: {
        stateKey: 'travelQuery',
        path: 'TravelAcidentInsurance/Search',
      },
      car: {
        stateKey: 'carQuery',
        path: 'VehicleInsurance/Search',
        
      },
      motor: {
        stateKey: 'motorQuery',
        path: 'MotorcycleInsurance/Search',
      }
    };
    const currInsu = insus[type];
    const key = currInsu.stateKey;
    commit(RESET_PRODUCTS_MUTATION);
    const payload = type === 'car' || 'motor'
      ? { ...queryModel, carNo: formatCarNo }
      : { ...queryModel };
    const res = await axios.post(currInsu.path, payload);
    const { success, result } = res.data;
    if (!success) throw new Error('很抱歉，系統繁忙中，請稍後再試，謝謝您');
    commit(SET_QUERY_MUTATION, { ...queryModel, key, tips });
    commit(SET_PRODUCTS_MUTATION, result);
    if (name === 'index') return router.push({ name: 'insurance', params: { type } });
  }
);
*//*
const fetchModalDetail = catchErrors(async ({ commit }, selectedArr) => {
  const [firstInsu, secInsu = null] = selectedArr;
  const firstRes = await axios.post('insurance/getInsuDetails', firstInsu);
  const firstDetail = { ...firstRes.data.result.insuDetails, selectedArr };
  if (!secInsu) {
    commit(INSU_MODAL_MUTATION, firstDetail);
    return;
  }
  const secRes = await axios.post('insurance/getInsuDetails', secInsu);
  const secDetail = secRes.data.result.insuDetails;
  const combineDetails = [firstDetail, secDetail].reduce((acc, obj, index) => {
    if (index === 0) return { ...obj };
    return {
      ...acc,
      lists: [...acc.lists, ...obj.lists],
      insuIds: [acc.insuId, obj.insuId],
      insuName: `${acc.insuName} ${obj.insuName}`,
      insuNames: [acc.insuName, obj.insuName],
      premiums: acc.premiums + obj.premiums,
      prodPolicies: [...acc.prodPolicies, ...obj.prodPolicies]
    };
  }, {});
  commit(INSU_MODAL_MUTATION, combineDetails);
});
*//*
const handleProductScroll = (context, element) => {
  const el = document.querySelector(element);
  const position = el.getBoundingClientRect();
  animateScroll(position.top - 100);
};
*/
//type-car ,prodPolicies,profile
const handlePurchase2 = async ({ commit }, { type, prodDetail, queryModel }) => {
  commit(INSU_MODAL_MUTATION, null);
  //console.log("renewal-type, prodDetail, queryModel:"+type+"        "+JSON.stringify(prodDetail)+"        "+ JSON.stringify(queryModel));
  //console.log("prodDetail-action.js:"+JSON.stringify(prodDetail));
  /*const { 
   prodPolicies,
    selectedArr
  } = prodDetail;
*/
  const prodPolicies= prodDetail.prodPolicies;  
  //console.log("prodPolicies1-action.js:"+prodPolicies);
//console.log("type-action.js:"+type);
const infos =[{
  insuName:prodDetail.insuName,
    isCompulsory: prodDetail.prodType === 'compulsory',
    insuCompany: prodDetail.insuCompany,
    insuId: prodDetail.insuId
}]

//console.log("infos-action.js:"+infos);
const selectedArr=infos;
/*
  const infos = selectedArr.map(item => ({ 
    insuName: item.insuName,
    isCompulsory: item.prodType === 'compulsory',
    insuCompany: item.insuCompany,
    insuId: item.insuId
  }));
  */
  switch (type) {
    case ('car'):
      commit(SET_CARPROFILE, { source: 'filter', profile: queryModel });
      break;
    case ('motor'):
      commit(SET_MOTORPROFILE, { source: 'filter', profile: queryModel });
      break;
    default: 
      commit(SET_TRAVELFILTER_FORM, queryModel);
  }

  commit(SET_CHECKOUT_PRODPOLICIES, prodPolicies);
  commit(SET_INSUINFOS, { insuType: type, infos });
  router.push({ name: 'checkoutInfo' });
};

export default {
 // [FETCH_INSU_ACTION]: fetchInsurances,
 // [FETCH_DETAILS_ACTION]: fetchModalDetail,
  //[HANDLE_PAGE_SCROLL]: handleProductScroll,
  [HANDLE_PURCHASE_ACTION2]: handlePurchase2
};